import type { NavigationScreen } from 'app/types/navigation';
import { useUISize } from 'app/utils/web-helpers';
import React from 'react';
import { LandingPageScreen as LandingPageScreenLarge } from './index.large';
import { LandingPageScreen as LandingPageScreenSmall } from './index.small';

export const LandingPageScreen: NavigationScreen<'landing-page'> = ({ ...rest }) => {
  const { isSmallUI } = useUISize();

  if (isSmallUI) {
    return <LandingPageScreenSmall {...rest} />;
  }
  return <LandingPageScreenLarge {...rest} />;
};
